(function () {
  const STORAGE_KEY = 'pdpFurnitureSet';
  const PARAM = 'fs';

  function readPayload() {
    const el = document.getElementById('PdpFurnitureSetsPayload');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return null;
    }
  }

  function getUrlHandle() {
    try {
      return new URLSearchParams(window.location.search).get(PARAM);
    } catch (error) {
      return null;
    }
  }

  function readStored() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY));
    } catch (error) {
      return null;
    }
  }

  function saveStored(set) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(set));
    } catch (error) {
      /* ignore quota / private mode */
    }
  }

  function productInSet(set, productId) {
    return Boolean(
      set &&
        Array.isArray(set.items) &&
        set.items.some(function (item) {
          return String(item.id) === String(productId);
        })
    );
  }

  function resolveActive(payload) {
    const assigned = (payload && payload.assigned) || [];
    const productId = payload && payload.productId;
    const urlHandle = getUrlHandle();
    const stored = readStored();

    if (assigned.length) {
      if (urlHandle) {
        const match = assigned.find(function (set) {
          return set.handle === urlHandle;
        });
        if (match) return match;
      }
      return assigned[0];
    }

    if (stored && productInSet(stored, productId) && (!urlHandle || urlHandle === stored.handle)) {
      return stored;
    }

    return null;
  }

  function withSetParam(href, currentHandle) {
    if (!currentHandle) return href;
    try {
      const url = new URL(href, window.location.origin);
      url.searchParams.set(PARAM, currentHandle);
      return url.pathname + url.search + url.hash;
    } catch (error) {
      const join = href.indexOf('?') === -1 ? '?' : '&';
      return href + join + PARAM + '=' + encodeURIComponent(currentHandle);
    }
  }

  function itemHref(item, currentHandle) {
    return withSetParam(item.url, currentHandle);
  }

  function syncLinks(currentHandle) {
    if (!currentHandle) return;
    document.querySelectorAll('[data-furniture-set-slot] a[href]').forEach(function (link) {
      link.setAttribute('href', withSetParam(link.getAttribute('href'), currentHandle));
    });
  }

  function syncUrl(currentHandle) {
    if (!currentHandle || !window.history || !window.history.replaceState) return;
    if (getUrlHandle() === currentHandle) return;
    try {
      const url = new URL(window.location.href);
      url.searchParams.set(PARAM, currentHandle);
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    } catch (error) {
      /* ignore */
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildHtml(set, productId, listStyle) {
    const altClass = listStyle === 'alt' ? ' key-accesories--alt' : '';
    const header = listStyle === 'alt' ? 'In this look: ' : 'Complete the Look';
    const cards = (set.items || [])
      .map(function (item) {
        const current = String(item.id) === String(productId) ? ' upsell-card--current' : '';
        const img = item.image
          ? '<img src="' +
            escapeHtml(item.image) +
            '" alt="' +
            escapeHtml(item.title) +
            '" loading="lazy" width="150">'
          : '';
        return (
          '<a href="' +
          escapeHtml(itemHref(item, set.handle)) +
          '">' +
          '<div class="upsell-card' +
          current +
          '">' +
          '<div class="fc-body">' +
          img +
          '</div>' +
          '<div class="fc-price">' +
          item.price +
          '</div>' +
          '</div>' +
          '</a>'
        );
      })
      .join('');

    return (
      '<div class="key-accesories' +
      altClass +
      '">' +
      '<div class="key-accesories-header">' +
      header +
      '</div>' +
      '<div class="slider" role="region" aria-label="Item Slider">' +
      '<div class="slider-track">' +
      cards +
      '</div>' +
      '</div>' +
      '</div>'
    );
  }

  function renderSet(set, productId) {
    const memberSlot = document.querySelector('[data-furniture-set-slot="member"]');
    const heroDesktop = document.querySelector('[data-furniture-set-slot="hero-desktop"]');
    const heroMobile = document.querySelector('[data-furniture-set-slot="hero-mobile"]');
    const desktopHtml = buildHtml(set, productId, '');
    const mobileHtml = buildHtml(set, productId, 'alt');

    if (memberSlot) memberSlot.innerHTML = '';
    if (heroDesktop) heroDesktop.innerHTML = desktopHtml;
    if (heroMobile) heroMobile.innerHTML = mobileHtml;
  }

  function init() {
    const payload = readPayload();
    if (!payload) return;

    const active = resolveActive(payload);
    if (!active || !active.items || !active.items.length) return;

    saveStored(active);
    syncUrl(active.handle);
    renderSet(active, payload.productId);
    syncLinks(active.handle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
